import { RequestedPartDetail } from "@/lib/queries/types";
import SwitchOperation from "./SwitchOperation";
import RowLayout from "./lib/RowLayout";
import { components } from "@/lib/ApiSchema";
import Button from "@/lib/Button";
import FooterRow from "./FooterRow";
import { quantityColumnWidth } from "./constants";
import useOperationListContext from "./lib/useOperationListContext";
import OperationContext from "./lib/OperationContext";
import OperationListContext from "./lib/OperationListContext";
import QuantityInParent from "../QuantityInParent";
import useUpdateOperation from "@/lib/queries/useUpdateOperation";
import { Link, useParams } from "react-router";
import { getUrl } from "@/lib/useToPage";
import PartThumbnail from "@/lib/PartThumbnail";

export default function SubpartList({
  subparts,
  canEdit,
}: {
  subparts: components["schemas"]["RequestedPartWithOperationsSchema"][];
  canEdit: boolean;
}) {
  const updateOperation = useUpdateOperation();
  const { teamSlug, rfqId } = useParams();

  const canEditSubpart = (
    subpart: components["schemas"]["RequestedPartWithOperationsSchema"],
  ) => {
    return canEdit && subpart.treat_as_ots;
  };

  return (
    <div className="flex flex-col gap-4">
      {subparts.map((subPart) => (
        <div key={subPart.id} className="border-5 border-slate-300 rounded-md">
          <OperationListContext.Provider
            value={{ quantities: subPart.requested_quantities }}
            key={subPart.id}
          >
            <RowLayout
              left={<Left part={subPart} canEdit={canEdit} />}
              right={<Right />}
              className="sticky top-8"
            />
            {canEditSubpart(subPart) &&
              subPart.operations.slice(0, 2).map((data) => (
                <OperationContext.Provider
                  value={{
                    operationData: data,
                    allowActions: false,
                    updateOperation,
                  }}
                  key={data.id}
                >
                  <SwitchOperation type={data.type} />
                </OperationContext.Provider>
              ))}
            {!canEditSubpart(subPart) && (
              <FooterRow
                operations={subPart.operations}
                left={
                  <Link
                    to={getUrl("part", {
                      teamSlug: teamSlug!,
                      rfqId: rfqId!,
                      partId: subPart.id,
                    })}
                  >
                    <Button className="ml-4" secondary>
                      Open Full Estimate
                    </Button>
                  </Link>
                }
              />
            )}
          </OperationListContext.Provider>
        </div>
      ))}
    </div>
  );
}

function Left({
  part,
  canEdit,
}: {
  part: RequestedPartDetail;
  canEdit: boolean;
}) {
  return (
    <div className="w-full px-2 flex justify-between items-center">
      <div className="flex items-center gap-1">
        <PartThumbnail
          url={part.thumbnail_url}
          className="border-[0.8px] border-slate-200 size-15 rounded-xs"
        />

        {part.qty_for_parent && (
          <QuantityInParent part={part} canEdit={canEdit} />
        )}
        <div>
          {part.part_number} <span className="text-slate-500">Rev</span>{" "}
          {part.revision_number}
        </div>
      </div>
    </div>
  );
}

function Right() {
  const { quantities } = useOperationListContext();
  return (
    <div className="flex divide-x divide-slate-100 text-sm">
      {quantities.map((q, i) => (
        <div
          key={i}
          className="flex justify-center items-center"
          style={{
            maxWidth: quantityColumnWidth,
            minWidth: quantityColumnWidth,
          }}
        >
          {q}
        </div>
      ))}
    </div>
  );
}
